module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume_pc/icon_q-6300fd918d1b74b8c2ca587256c3aaa2.png";